(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cottonil-collection"] && !Shopify.designMode) return;
  try {
    
function initCottonilCollection(root){
 if(!root || root.dataset.ready)return;root.dataset.ready='true';
 const panel=root.querySelector('.cc-filters'), media=matchMedia('(min-width:768px)');
 const sync=()=>{panel.open=media.matches};sync();media.addEventListener('change',sync);
 root.querySelectorAll('.cc-price-slider').forEach(slider=>slider.addEventListener('input',()=>{slider.closest('.cc-filter-group').querySelector('.cc-price-inputs label:last-child input').value=slider.value}));
 root.querySelector('.cc-sort select').addEventListener('change',e=>e.target.form.requestSubmit());
 let saved=[];try{saved=JSON.parse(localStorage.getItem('cottonil_favorites')||'[]');if(!Array.isArray(saved))saved=[]}catch{}
 const paint=()=>root.querySelectorAll('.cc-favorite').forEach(b=>b.setAttribute('aria-pressed',String(saved.includes(b.dataset.productId))));paint();
 root.addEventListener('click',async e=>{
  const fav=e.target.closest('.cc-favorite');if(fav){const id=fav.dataset.productId;saved=saved.includes(id)?saved.filter(x=>x!==id):[...saved,id];try{localStorage.setItem('cottonil_favorites',JSON.stringify(saved))}catch{}paint();return}
  const more=e.target.closest('[data-cc-more]');if(!more)return;e.preventDefault();if(more.getAttribute('aria-busy')==='true')return;more.setAttribute('aria-busy','true');
  try{const response=await fetch(more.href);if(!response.ok)throw new Error();const page=new DOMParser().parseFromString(await response.text(),'text/html');const grid=page.querySelector('[data-cc-grid]'),pagination=page.querySelector('[data-cc-pagination]');if(!grid||!pagination)throw new Error();const first=grid.firstElementChild;root.querySelector('[data-cc-grid]').append(...grid.children);root.querySelector('[data-cc-pagination]').replaceWith(pagination);const count=root.querySelectorAll('.cc-card').length;const status=pagination.querySelector('p');status.textContent=status.textContent.replace(/\d+/,String(count));paint();if(first){first.tabIndex=-1;first.focus({preventScroll:true})}}catch{location.href=more.href}
 });
}
document.querySelectorAll('[data-cc]').forEach(initCottonilCollection);document.addEventListener('shopify:section:load',e=>initCottonilCollection(e.target.querySelector('[data-cc]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cottonil-reference-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const tabs = [...root.querySelectorAll('[data-ref-tab]')];
    function activate(tab) {
      tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      root.querySelectorAll('[data-ref-panel]').forEach(panel => { panel.hidden = panel.dataset.refPanel !== tab.dataset.refTab; });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowLeft') target = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowRight') target = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') target = tabs[0];
        if (event.key === 'End') target = tabs[tabs.length - 1];
        if (target) { event.preventDefault(); activate(target); target.focus(); }
      });
    });
    let favorites = [];
    try { favorites = JSON.parse(localStorage.getItem('cottonil_favorites') || '[]'); if (!Array.isArray(favorites)) favorites = []; } catch {}
    root.querySelectorAll('.rf-favorite').forEach(button => {
      button.setAttribute('aria-pressed', String(favorites.includes(button.dataset.productId)));
      button.addEventListener('click', () => {
        const id = button.dataset.productId;
        favorites = favorites.includes(id) ? favorites.filter(item => item !== id) : [...favorites, id];
        try { localStorage.setItem('cottonil_favorites', JSON.stringify(favorites)); } catch {}
        root.querySelectorAll('.rf-favorite').forEach(item => item.setAttribute('aria-pressed', String(favorites.includes(item.dataset.productId))));
      });
    });
  };
  document.querySelectorAll('[data-reference-home]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-reference-home]')));
})();

  } catch(e) { console.error(e); }
})();
})();
